import React from 'react';
import * as XLSX from 'xlsx';
import {
  Box,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  IconButton,
  Tooltip,
  LinearProgress,
  useTheme,
  useMediaQuery,
  Chip,
  Alert,
  Snackbar,
  Card,
  CardContent,
  Tabs,
  Tab,
  Autocomplete,
  Checkbox,
  FormControlLabel,
  FormGroup,
  ToggleButton,
  ToggleButtonGroup,
  Stack,
  Divider,
  TablePagination,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { API_BASE } from '../api';
import { formatDateBr } from '../utils/datetime';
import { useAuth } from '../contexts/AuthContext';
import {
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Visibility as ViewIcon,
  AddCircleOutline as AddNewIcon,
  PhotoCamera,
  Videocam,
  Description as DocumentIcon,
  Close as CloseIcon,
  ContentCopy as DuplicateIcon,
  Today as TodayIcon,
  FileDownload as ExportIcon,
  WarningAmber as WarningAmberIcon,
} from '@mui/icons-material';

const TIPOS_INVESTIMENTO = ['Avarias', 'Manutenção', 'Mobiliário', 'Obras', 'Projetos', 'Reformas', 'UD'];

const CATEGORIAS_INVESTIMENTO = [
  'Aço', 'Aluguel de Equipamentos', 'Argamassa', 'Avarias', 'Cerâmica', 'Civil',
  'Concreto', 'Elétrica', 'Elevador', 'Ferragens', 'Forro', 'Frete', 'Fundação', 'Gerador', 'Gesso',
  'Hidráulica', 'Incêndio', 'Impermeabilização', 'Locação', 'Madeira', 'Mão de Obra',
  'Materiais de Construção', 'Mármores e Granitos', 'Mobiliários', 'Paisagismo',
  'Pintura', 'Pisos e Revestimentos', 'Porta Pallets', 'Portas Rápidas', 'Projetos', 'Projetos Complementares', 'Refrigeração',
  'Serralheria', 'Sinistro', 'T.I', 'Terraplanagem', 'Tintas', 'Vidros', 'Outros',
];

const ANOS_EXPORT = (() => {
  const anos = [];
  const atual = new Date().getFullYear();
  for (let a = atual; a >= atual - 5; a--) anos.push(a);
  return anos;
})();

const MESES_EXPORT = [
  { v: 1, l: 'Janeiro' }, { v: 2, l: 'Fevereiro' }, { v: 3, l: 'Março' },
  { v: 4, l: 'Abril' }, { v: 5, l: 'Maio' }, { v: 6, l: 'Junho' },
  { v: 7, l: 'Julho' }, { v: 8, l: 'Agosto' }, { v: 9, l: 'Setembro' },
  { v: 10, l: 'Outubro' }, { v: 11, l: 'Novembro' }, { v: 12, l: 'Dezembro' },
];

function Despesas() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();
  const { token, isAdmin } = useAuth();
  const isAdminUser = typeof isAdmin === 'function' ? isAdmin() : !!isAdmin;
  // const canRead = hasPermission('/despesas', 'read');
  // const canCreate = hasPermission('/despesas', 'create');
  // const canUpdate = hasPermission('/despesas', 'update');
  // const canDelete = hasPermission('/despesas', 'delete');

  // Estados principais
  const [despesas, setDespesas] = React.useState([]);
  const [clientes, setClientes] = React.useState([]);
  const [fornecedores, setFornecedores] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [allowedClienteIds, setAllowedClienteIds] = React.useState(null);
  const allowedClienteIdsRef = React.useRef(allowedClienteIds);
  const filtroClienteRef = React.useRef('');

  React.useEffect(() => {
    allowedClienteIdsRef.current = allowedClienteIds;
  }, [allowedClienteIds]);

  // Paginação
  const [page, setPage] = React.useState(0);
  const ROWS_PER_PAGE = 30;

  // Estados de filtros
  const [filtroCliente, setFiltroCliente] = React.useState('');
  const [filtroSituacao, setFiltroSituacao] = React.useState('');
  const [filtroFornecedor, setFiltroFornecedor] = React.useState('');
  const [filtroDataInicio, setFiltroDataInicio] = React.useState('');
  const [filtroDataFim, setFiltroDataFim] = React.useState('');
  const [filtroOS, setFiltroOS] = React.useState('');
  const [filtroCategoria, setFiltroCategoria] = React.useState('');
  const [filtroTipo, setFiltroTipo] = React.useState('');
  const [filtroAndamento, setFiltroAndamento] = React.useState('');

  // Estados para modais
  const [openModal, setOpenModal] = React.useState(false);
  const [editingDespesa, setEditingDespesa] = React.useState(null);
  const [saving, setSaving] = React.useState(false);
  const [valorCents, setValorCents] = React.useState(0);
  const [descontoCents, setDescontoCents] = React.useState(0);

  // Estados para upload de Excel
  const [openUploadModal, setOpenUploadModal] = React.useState(false);
  const [uploadFile, setUploadFile] = React.useState(null);
  const [uploadProgress, setUploadProgress] = React.useState(0);

  // Estado para modal de novo fornecedor
  const [openNovoFornecedor, setOpenNovoFornecedor] = React.useState(false);
  const [novoFornecedor, setNovoFornecedor] = React.useState({
    nome: '',
    telefone: '',
    categoria: '',
  });

  // Estados para formulário
  const [formData, setFormData] = React.useState({
    id_cliente: '',
    fornecedor_id: '',
    numero_os: '',
    servico: '',
    valor: '',
    desconto: '',
    data: '',
    categoria: '',
    tipo: '',
    status: 'Pendente',
    andamento: '',
    observacoes: '',
  });

  // Estados para upload de arquivos de mídia
  const [fotos, setFotos] = React.useState([]);
  const [documentos, setDocumentos] = React.useState([]);
  const [videos, setVideos] = React.useState([]);
  const [existingFotos, setExistingFotos] = React.useState([]);
  const [existingDocs, setExistingDocs] = React.useState([]);
  const [existingVideos, setExistingVideos] = React.useState([]);
  const fotoInputRef = React.useRef(null);
  const docInputRef = React.useRef(null);
  const videoInputRef = React.useRef(null);

  // Estados para notificações
  const [snackbar, setSnackbar] = React.useState({
    open: false,
    message: '',
    severity: 'success',
  });

  // Estado para aba ativa
  const [activeTab, setActiveTab] = React.useState(0);

  // Estados para aba Contratos
  const [contratosData, setContratosData] = React.useState([]);
  const [contratosLoading, setContratosLoading] = React.useState(false);
  const [contratosClienteId, setContratosClienteId] = React.useState('');
  const [contratosSituacao, setContratosSituacao] = React.useState('');
  const [contratosSearch, setContratosSearch] = React.useState('');

  // Estados para modal de exportação Excel
  const [openExportModal, setOpenExportModal] = React.useState(false);
  const [exportOpts, setExportOpts] = React.useState({
    periodo: 'ult30',
    mes: new Date().getMonth() + 1,
    ano: new Date().getFullYear(),
    todosClientes: true,
    clienteIds: [],
    fornecedorId: '',
    tipo: '',
    situacao: '',
    categoria: '',
  });

  // --- Carregar contratos para aba Contratos ---
  const fetchContratos = React.useCallback(async () => {
    setContratosLoading(true);
    try {
      const res = await fetch(`${API_BASE}/contratos`, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      if (res.ok) {
        const data = await res.json();
        setContratosData(Array.isArray(data) ? data : []);
      } else {
        setContratosData([]);
      }
    } catch { setContratosData([]); }
    finally { setContratosLoading(false); }
  }, [token]);

  // Abre a aba → carrega contratos
  React.useEffect(() => {
    if (activeTab === 1) fetchContratos();
  }, [activeTab]); // eslint-disable-line react-hooks/exhaustive-deps

  // --- Lock de edição para sincronização com OS/NFE ---
  const acquireLock = React.useCallback(async () => {
    try {
      await fetch(`${API_BASE}/editing-lock/despesas`, {
        method: 'POST',
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
    } catch (e) {
      /* ignora */
    }
  }, [token]);

  const releaseLock = React.useCallback(async () => {
    try {
      await fetch(`${API_BASE}/editing-lock/despesas`, {
        method: 'DELETE',
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
    } catch (e) {
      /* ignora */
    }
  }, [token]);

  // Libera lock ao sair da página
  React.useEffect(() => {
    const handleUnload = () => {
      if (token) {
        navigator.sendBeacon &&
          navigator.sendBeacon(`${API_BASE}/editing-lock/despesas?_method=DELETE`);
      }
    };
    window.addEventListener('beforeunload', handleUnload);
    return () => {
      window.removeEventListener('beforeunload', handleUnload);
      releaseLock();
    };
  }, [releaseLock, token]);

  React.useEffect(() => {
    setPage(0);
  }, [
    filtroFornecedor,
    filtroSituacao,
    filtroDataInicio,
    filtroDataFim,
    filtroOS,
    filtroCategoria,
    filtroTipo,
    filtroAndamento,
  ]);

  const despesasFiltradas = React.useMemo(() => {
    return despesas.filter((d) => {
      let match = true;
      if (filtroFornecedor) {
        if (String(d.fornecedor_id) !== String(filtroFornecedor)) {
          match = false;
        }
      }
      if (filtroSituacao) {
        const sStatus = d.status ? d.status.toLowerCase() : '';
        if (sStatus !== filtroSituacao.toLowerCase()) {
          match = false;
        }
      }
      if (filtroDataInicio) {
        if (!d.data || d.data < filtroDataInicio) match = false;
      }
      if (filtroDataFim) {
        if (!d.data || d.data > filtroDataFim) match = false;
      }
      if (filtroOS) {
        if (!d.numero_os || !String(d.numero_os).toLowerCase().includes(filtroOS.toLowerCase())) {
          match = false;
        }
      }
      if (filtroCategoria) {
        if (String(d.categoria) !== String(filtroCategoria)) {
          match = false;
        }
      }
      if (filtroTipo) {
        if (String(d.tipo || '') !== String(filtroTipo)) {
          match = false;
        }
      }
      if (filtroAndamento) {
        if (String(d.andamento || '') !== String(filtroAndamento)) {
          match = false;
        }
      }
      return match;
    });
  }, [
    despesas,
    filtroFornecedor,
    filtroSituacao,
    filtroDataInicio,
    filtroDataFim,
    filtroOS,
    filtroCategoria,
    filtroTipo,
    filtroAndamento,
  ]);

  const totalDespesasValor = React.useMemo(() => {
    return despesasFiltradas.reduce((sum, d) => sum + Number(d.valor || 0), 0);
  }, [despesasFiltradas]);

  const totalDescontosValor = React.useMemo(() => {
    return despesasFiltradas.reduce((sum, d) => sum + Number(d.desconto || 0), 0);
  }, [despesasFiltradas]);

  const isFromConsultaOsNfe = React.useCallback(
    (record) => record?.origem_sistema === 'consulta_os_nfe',
    []
  );

  const isEmAndamentoAtrasado = React.useCallback((despesa) => {
    if (despesa.andamento !== 'Em andamento') return false;
    const ref = despesa.updated_at || despesa.created_at;
    if (!ref) return false;
    return Date.now() - new Date(ref).getTime() > 3 * 24 * 60 * 60 * 1000;
  }, []);

  // Carregar despesas
  const loadDespesas = React.useCallback(async () => {
    const clienteId = filtroClienteRef.current;
    if (!clienteId) {
      setDespesas([]);
      return;
    }
    setLoading(true);
    try {
      const headers = token ? { Authorization: `Bearer ${token}` } : {};
      let permittedIds = allowedClienteIdsRef.current;
      if (permittedIds === null) {
        try {
          const meResponse = await fetch(`${API_BASE}/me/clientes`, { headers });
          if (meResponse.ok) {
            const meData = await meResponse.json();
            permittedIds = (meData.clientes || []).map(Number);
            setAllowedClienteIds(permittedIds);
          }
        } catch (e) {
          console.warn('Endpoint /me/clientes não disponível');
        }
      }
      const isTodos = clienteId === 'all';
      let despesasUrl = isTodos ? `${API_BASE}/despesas?` : `${API_BASE}/despesas?cliente_id=${clienteId}&`;
      if (permittedIds && permittedIds.length > 0) {
        const qs = permittedIds.map((id) => `cliente_ids[]=${id}`).join('&');
        despesasUrl += qs;
      }
      const response = await fetch(despesasUrl, { headers });
      if (response.ok) {
        const data = await response.json();
        setDespesas(data);
      } else {
        throw new Error('Erro ao carregar despesas');
      }
    } catch (e) {
      console.error(e);
      setSnackbar({ open: true, message: 'Erro ao carregar despesas', severity: 'error' });
    }
    setLoading(false);
  }, [token]);

  const loadClientes = React.useCallback(async () => {
    try {
      const headers = token ? { Authorization: `Bearer ${token}` } : {};

      // Buscar clientes permitidos do usuário
      let clienteIds = allowedClienteIdsRef.current;
      if (clienteIds === null) {
        try {
          const meResponse = await fetch(`${API_BASE}/me/clientes`, { headers });
          if (meResponse.ok) {
            const meData = await meResponse.json();
            clienteIds = (meData.clientes || []).map(Number);
            setAllowedClienteIds(clienteIds);
          }
        } catch (e) {
          console.warn('Endpoint /me/clientes não disponível');
        }
      }

      let response = await fetch(`${API_BASE}/clientes`, { headers });
      if (!response.ok && (response.status === 404 || response.status === 405)) {
        response = await fetch(`${API_BASE}/clientes/`, { headers });
      }
      if (!response.ok) throw new Error('Erro ao carregar clientes');
      let data = await response.json();
      let list = Array.isArray(data) ? data : [];
      // Filtrar por clientes permitidos
      if (clienteIds && clienteIds.length > 0) {
        list = list.filter((c) => clienteIds.includes(Number(c.id)));
      }
      setClientes(list);
      // Auto-seleciona se o usuário tem acesso a apenas 1 cliente
      if (list.length === 1 && !filtroClienteRef.current) {
        filtroClienteRef.current = String(list[0].id);
        setFiltroCliente(String(list[0].id));
      }
    } catch (e) {
      console.error(e);
      setClientes([]);
      setSnackbar({
        open: true,
        message: 'Erro ao carregar clientes cadastrados',
        severity: 'error',
      });
    }
  }, [token]);

  const loadFornecedores = React.useCallback(async () => {
    try {
      const headers = token ? { Authorization: `Bearer ${token}` } : {};
      const response = await fetch(`${API_BASE}/fornecedores`, { headers });
      if (response.ok) {
        const data = await response.json();
        setFornecedores(Array.isArray(data) ? data.filter((f) => f.ativo !== false) : []);
      }
    } catch (e) {
      console.error(e);
    }
  }, [token]);

  React.useEffect(() => {
    loadClientes();
    loadFornecedores();
  }, [loadClientes, loadFornecedores]);

  // Recarrega despesas quando cliente muda; limpa dados se vazio
  React.useEffect(() => {
    filtroClienteRef.current = filtroCliente;
    setPage(0);
    if (!filtroCliente) {
      setDespesas([]);
    } else {
      loadDespesas();
    }
  }, [filtroCliente, loadDespesas]);

  const handleAndamentoInline = React.useCallback(async (id, novoAndamento) => {
    setDespesas((prev) =>
      prev.map((d) => (d.id === id ? { ...d, andamento: novoAndamento, updated_at: new Date().toISOString() } : d))
    );
    try {
      await fetch(`${API_BASE}/despesas/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify({ andamento: novoAndamento }),
      });
    } catch (e) {
      loadDespesas();
      setSnackbar({ open: true, message: 'Erro ao atualizar andamento', severity: 'error' });
    }
  }, [token, loadDespesas]);

  const handleStatusInline = React.useCallback(async (id, novoStatus) => {
    const statusAnterior = despesas.find((d) => d.id === id)?.status;
    setDespesas((prev) =>
      prev.map((d) => (d.id === id ? { ...d, status: novoStatus } : d))
    );
    try {
      const response = await fetch(`${API_BASE}/despesas/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify({ status: novoStatus }),
      });
      if (!response.ok) {
        setDespesas((prev) =>
          prev.map((d) => (d.id === id ? { ...d, status: statusAnterior } : d))
        );
        const err = await response.json().catch(() => ({}));
        setSnackbar({ open: true, message: err?.errors?.[0] || err?.detail || 'Erro ao atualizar status', severity: 'error' });
      } else {
        setSnackbar({ open: true, message: `Status atualizado para ${novoStatus}`, severity: 'success' });
      }
    } catch (e) {
      setDespesas((prev) =>
        prev.map((d) => (d.id === id ? { ...d, status: statusAnterior } : d))
      );
      loadDespesas();
      setSnackbar({ open: true, message: 'Erro ao atualizar status', severity: 'error' });
    }
  }, [token, loadDespesas, despesas]);

  // Handlers do formulário
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleDelete = async (despesa) => {
    if (!isAdminUser) return;
    if (!despesa?.id) return;
    if (!window.confirm('Deseja realmente excluir esta despesa?')) return;

    await acquireLock();
    try {
      const response = await fetch(`${API_BASE}/despesas/${despesa.id}`, {
        method: 'DELETE',
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });

      if (response.ok || response.status === 204) {
        loadDespesas();
        setSnackbar({
          open: true,
          message: 'Despesa excluída com sucesso!',
          severity: 'success',
        });
      } else {
        throw new Error('Erro ao excluir despesa');
      }
    } catch (e) {
      console.error(e);
      setSnackbar({
        open: true,
        message: 'Erro ao excluir despesa',
        severity: 'error',
      });
    } finally {
      await releaseLock();
    }
  };

  // Handlers de upload de arquivos
  const handleFotoChange = (e) => {
    const files = Array.from(e.target.files);
    const novasFotos = files.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
    }));
    setFotos((prev) => [...prev, ...novasFotos]);
    e.target.value = '';
  };

  const removerFoto = (index) => {
    setFotos((prev) => {
      URL.revokeObjectURL(prev[index].preview);
      return prev.filter((_, i) => i !== index);
    });
  };

  const handleDocChange = (e) => {
    const files = Array.from(e.target.files);
    const novosDocumentos = files.map((file) => ({
      file,
      name: file.name,
    }));
    setDocumentos((prev) => [...prev, ...novosDocumentos]);
    e.target.value = '';
  };

  const removerDocumento = (index) => {
    setDocumentos((prev) => prev.filter((_, i) => i !== index));
  };

  const handleVideoChange = (e) => {
    const files = Array.from(e.target.files);
    const novosVideos = files.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
    }));
    setVideos((prev) => [...prev, ...novosVideos]);
    e.target.value = '';
  };

  const removerVideo = (index) => {
    setVideos((prev) => {
      URL.revokeObjectURL(prev[index].preview);
      return prev.filter((_, i) => i !== index);
    });
  };

  // Formata centavos (inteiro) como string pt-BR: 210000 → "2.100,00"
  const centsToDisplay = (cents) => {
    const abs = Math.abs(Math.round(cents));
    const str = String(abs).padStart(3, '0');
    const reais = str.slice(0, -2);
    const centavos = str.slice(-2);
    const reaisNum = parseInt(reais, 10);
    return reaisNum.toLocaleString('pt-BR') + ',' + centavos;
  };

  // Converte valor salvo (string ou número) em centavos inteiros
  // Suporta formato pt-BR ("41.904,94") e EN ("41904.94")
  const valueToCents = (v) => {
    if (!v && v !== 0) return 0;
    const s = String(v).trim();
    if (!s) return 0;
    let num;
    if (s.includes(',')) {
      // pt-BR: ponto = milhar, vírgula = decimal
      num = parseFloat(s.replace(/\./g, '').replace(',', '.'));
    } else {
      // EN: ponto = decimal
      num = parseFloat(s);
    }
    if (isNaN(num)) return 0;
    return Math.round(num * 100);
  };

  // Handler RTL: só aceita dígitos e backspace
  const makeCurrencyKeyDown = (setCents, setField) => (e) => {
    e.preventDefault();
    if (e.key >= '0' && e.key <= '9') {
      setCents((prev) => {
        const next = prev * 10 + parseInt(e.key, 10);
        const display = centsToDisplay(next);
        setField(display);
        return next;
      });
    } else if (e.key === 'Backspace') {
      setCents((prev) => {
        const next = Math.floor(prev / 10);
        const display = centsToDisplay(next);
        setField(display);
        return next;
      });
    }
  };

  // Sincroniza cents quando o modal abre com um valor existente
  React.useEffect(() => {
    if (openModal) {
      const vc = valueToCents(formData.valor);
      const dc = valueToCents(formData.desconto);
      setValorCents(vc);
      setDescontoCents(dc);
      setFormData((prev) => ({ ...prev, valor: centsToDisplay(vc), desconto: centsToDisplay(dc) }));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openModal]);

  const sanitizeValor = (v) => {
    if (!v && v !== 0) return '';
    const cleaned = String(v).replace(/\./g, '').replace(',', '.');
    const num = parseFloat(cleaned);
    if (isNaN(num)) return v;
    return (Math.round(num * 100) / 100).toFixed(2);
  };

  const handleSubmit = async () => {
    if (saving) return;
    setSaving(true);
    await acquireLock();
    try {
      const { id_cliente, fornecedor_id, ...rest } = formData;

      const url = editingDespesa
        ? `${API_BASE}/despesas/${editingDespesa.id}`
        : `${API_BASE}/despesas`;
      const method = editingDespesa ? 'PUT' : 'POST';

      // Usar FormData se houver arquivos
      const hasFiles = fotos.length > 0 || documentos.length > 0 || videos.length > 0;

      let response;
      if (hasFiles) {
        const formDataObj = new FormData();
        formDataObj.append('cliente_id', id_cliente ? Number(id_cliente) : '');
        formDataObj.append('fornecedor_id', fornecedor_id ? Number(fornecedor_id) : '');
        formDataObj.append('numero_os', formData.numero_os || '');
        formDataObj.append('servico', rest.servico || '');
        formDataObj.append('valor', sanitizeValor(rest.valor));
        formDataObj.append('data', rest.data || '');
        formDataObj.append('categoria', rest.categoria || '');
        formDataObj.append('tipo', rest.tipo || '');
        formDataObj.append('desconto', sanitizeValor(rest.desconto) || '0');
        formDataObj.append('status', rest.status || 'Pendente');
        formDataObj.append('andamento', rest.andamento || '');
        formDataObj.append('observacoes', rest.observacoes || '');

        // Adicionar fotos
        fotos.forEach((foto) => {
          if (foto.file) formDataObj.append('fotos', foto.file);
        });

        // Adicionar documentos
        documentos.forEach((doc) => {
          if (doc.file) formDataObj.append('documentos', doc.file);
        });

        // Adicionar vídeos
        videos.forEach((video) => {
          if (video.file) formDataObj.append('videos', video.file);
        });

        response = await fetch(url, {
          method,
          headers: token ? { Authorization: `Bearer ${token}` } : {},
          body: formDataObj,
        });
      } else {
        const payload = {
          ...rest,
          valor: sanitizeValor(rest.valor),
          desconto: sanitizeValor(rest.desconto) ? Number(sanitizeValor(rest.desconto)) : 0,
          cliente_id: id_cliente ? Number(id_cliente) : null,
          fornecedor_id: fornecedor_id ? Number(fornecedor_id) : null,
          numero_os: formData.numero_os || null,
        };

        response = await fetch(url, {
          method,
          headers: {
            'Content-Type': 'application/json',
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
          body: JSON.stringify(payload),
        });
      }

      if (response.ok) {
        setOpenModal(false);
        setEditingDespesa(null);
        setFormData({
          id_cliente: '',
          fornecedor_id: '',
          numero_os: '',
          servico: '',
          valor: '',
          desconto: '',
          data: '',
          categoria: '',
          tipo: '',
          status: 'Pendente',
          andamento: '',
          observacoes: '',
        });
        // Limpar arquivos
        fotos.forEach((f) => f.preview && URL.revokeObjectURL(f.preview));
        videos.forEach((v) => v.preview && URL.revokeObjectURL(v.preview));
        setFotos([]);
        setDocumentos([]);
        setVideos([]);
        setExistingFotos([]);
        setExistingDocs([]);
        setExistingVideos([]);

        // Lembrar últimos valores usados para pré-preencher próximo registro
        localStorage.setItem('despesa_last', JSON.stringify({
          id_cliente: formData.id_cliente,
          fornecedor_id: formData.fornecedor_id,
          categoria: formData.categoria,
          tipo: formData.tipo,
        }));
        loadDespesas();
        setSnackbar({
          open: true,
          message: editingDespesa
            ? 'Despesa atualizada com sucesso!'
            : 'Despesa adicionada com sucesso!',
          severity: 'success',
        });
      } else {
        const errorData = await response.json().catch(() => null);
        const errorMessage =
          errorData?.detail ||
          errorData?.error ||
          (Array.isArray(errorData?.errors) ? errorData.errors.join(', ') : null) ||
          'Erro ao salvar despesa';
        throw new Error(errorMessage);
      }
    } catch (e) {
      console.error(e);
      setSnackbar({
        open: true,
        message: e.message || 'Erro ao salvar despesa',
        severity: 'error',
      });
    } finally {
      await releaseLock();
      setSaving(false);
    }
  };

  const handleEdit = (despesa) => {
    setEditingDespesa(despesa);
    setFormData({
      id_cliente: despesa.cliente_id || despesa.id_cliente || '',
      fornecedor_id: despesa.fornecedor_id || '',
      numero_os: despesa.numero_os || '',
      servico: despesa.servico || '',
      valor: despesa.valor || '',
      desconto: despesa.desconto || '',
      data: despesa.data ? despesa.data.split('T')[0] : '',
      categoria: despesa.categoria || '',
      tipo: despesa.tipo || '',
      status: despesa.status || 'Pendente',
      andamento: despesa.andamento || '',
      observacoes: despesa.observacoes || '',
    });
    // Carregar arquivos existentes
    setExistingFotos(despesa.fotos_urls || []);
    setExistingDocs(despesa.documentos_urls || []);
    setExistingVideos(despesa.videos_urls || []);
    // Limpar novos arquivos
    setFotos([]);
    setDocumentos([]);
    setVideos([]);
    setOpenModal(true);
  };

  const handleNovaDespesa = () => {
    setEditingDespesa(null);
    const last = JSON.parse(localStorage.getItem('despesa_last') || '{}');
    setFormData({
      id_cliente: last.id_cliente || '',
      fornecedor_id: last.fornecedor_id || '',
      numero_os: '',
      servico: '',
      valor: '',
      desconto: '',
      data: new Date().toISOString().split('T')[0],
      categoria: last.categoria || '',
      tipo: last.tipo || '',
      status: 'Pendente',
      andamento: '',
      observacoes: '',
    });
    setFotos([]);
    setDocumentos([]);
    setVideos([]);
    setExistingFotos([]);
    setExistingDocs([]);
    setExistingVideos([]);
    setOpenModal(true);
  };

  const handleDuplicar = (despesa) => {
    setEditingDespesa(null);
    setFormData({
      id_cliente: String(despesa.cliente_id ?? despesa.id_cliente ?? ''),
      fornecedor_id: String(despesa.fornecedor_id ?? ''),
      numero_os: '',
      servico: despesa.servico || '',
      valor: despesa.valor || '',
      desconto: '',
      data: new Date().toISOString().split('T')[0],
      categoria: despesa.categoria || '',
      tipo: despesa.tipo || '',
      status: 'Pendente',
      andamento: '',
      observacoes: '',
    });
    setFotos([]);
    setDocumentos([]);
    setVideos([]);
    setExistingFotos([]);
    setExistingDocs([]);
    setExistingVideos([]);
    setOpenModal(true);
  };

  const handleView = (despesa) => {
    const cId = despesa.cliente_id ?? despesa.id_cliente;
    const cNome = cId
      ? clientes.find((c) => String(c.id) === String(cId))?.nome || `ID: ${cId}`
      : 'Geral';
    const fNome = despesa.fornecedor_id
      ? fornecedores.find((f) => f.id === despesa.fornecedor_id)?.nome || ''
      : '';
    alert(
      `Visualizando despesa:\nCliente: ${cNome}${fNome ? `\nFornecedor: ${fNome}` : ''}\nOS: ${despesa.numero_os || '-'}\nServiço: ${despesa.servico}\nValor: R$ ${despesa.valor}${Number(despesa.desconto) > 0 ? `\nDesconto: R$ ${despesa.desconto}` : ''}\nData: ${despesa.data ? formatDateBr(despesa.data) : '-'}\nStatus: ${despesa.status}${isFromConsultaOsNfe(despesa) ? '\nOrigem: Enviado Consulta OS/NFE' : ''}`
    );
  };

  // Handler para upload de Excel
  const handleFileUpload = async () => {
    if (!uploadFile) return;

    const formData = new FormData();
    formData.append('file', uploadFile);

    setUploadProgress(0);
    try {
      const xhr = new XMLHttpRequest();

      xhr.upload.onprogress = (e) => {
        if (e.lengthComputable) {
          setUploadProgress((e.loaded / e.total) * 100);
        }
      };

      xhr.onload = function () {
        if (xhr.status === 200) {
          setOpenUploadModal(false);
          setUploadFile(null);
          setUploadProgress(0);
          loadDespesas();
          setSnackbar({
            open: true,
            message: 'Arquivo Excel importado com sucesso!',
            severity: 'success',
          });
        } else {
          throw new Error('Erro no upload');
        }
      };

      xhr.onerror = function () {
        throw new Error('Erro de conexão');
      };

      xhr.open('POST', `${API_BASE}/despesas/upload-excel`);
      xhr.send(formData);
    } catch (e) {
      console.error(e);
      setSnackbar({
        open: true,
        message: 'Erro ao importar arquivo Excel',
        severity: 'error',
      });
      setUploadProgress(0);
    }
  };

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'pago':
        return 'success';
      case 'pendente':
        return 'warning';
      case 'cancelado':
        return 'error';
      default:
        return 'default';
    }
  };

  const handleExportExcel = () => {
    const { periodo, mes, ano, todosClientes, clienteIds, fornecedorId, tipo, situacao, categoria } = exportOpts;

    const hoje = new Date();
    let dataInicio = null;
    let dataFim = null;

    if (periodo === 'ult30') {
      const d = new Date(hoje); d.setDate(d.getDate() - 30);
      dataInicio = d.toISOString().slice(0, 10);
      dataFim = hoje.toISOString().slice(0, 10);
    } else if (periodo === 'ult60') {
      const d = new Date(hoje); d.setDate(d.getDate() - 60);
      dataInicio = d.toISOString().slice(0, 10);
      dataFim = hoje.toISOString().slice(0, 10);
    } else if (periodo === 'ult90') {
      const d = new Date(hoje); d.setDate(d.getDate() - 90);
      dataInicio = d.toISOString().slice(0, 10);
      dataFim = hoje.toISOString().slice(0, 10);
    } else if (periodo === 'mensal') {
      const lastDay = new Date(ano, mes, 0).getDate();
      dataInicio = `${ano}-${String(mes).padStart(2, '0')}-01`;
      dataFim = `${ano}-${String(mes).padStart(2, '0')}-${String(lastDay).padStart(2, '0')}`;
    } else if (periodo === 'anual') {
      dataInicio = `${ano}-01-01`;
      dataFim = `${ano}-12-31`;
    }

    const nomeCliente = (id) => {
      const c = clientes.find((x) => String(x.id) === String(id));
      return c ? c.nome : (id || '');
    };
    const nomeFornecedor = (id) => {
      const f = fornecedores.find((x) => String(x.id) === String(id));
      return f ? (f.nome || f.razao_social || `Fornecedor #${id}`) : (id || '');
    };

    const rows = despesas.filter((d) => {
      if (dataInicio && (!d.data || d.data < dataInicio)) return false;
      if (dataFim && (!d.data || d.data > dataFim)) return false;
      if (!todosClientes && clienteIds.length > 0) {
        const cId = String(d.cliente_id || d.id_cliente || '');
        if (!clienteIds.includes(cId)) return false;
      }
      if (fornecedorId && String(d.fornecedor_id) !== String(fornecedorId)) return false;
      if (tipo && String(d.tipo || '') !== tipo) return false;
      if (situacao && (d.status || '').toLowerCase() !== situacao.toLowerCase()) return false;
      if (categoria && String(d.categoria || '') !== categoria) return false;
      return true;
    });

    const sheetData = rows.map((d) => ({
      'Cliente': nomeCliente(d.cliente_id || d.id_cliente),
      'Fornecedor': nomeFornecedor(d.fornecedor_id),
      'Nº OS': d.numero_os || '',
      'Serviço': d.servico || '',
      'Valor (R$)': Number(d.valor || 0),
      'Desconto (R$)': Number(d.desconto || 0),
      'Líquido (R$)': Number(d.valor || 0) - Number(d.desconto || 0),
      'Data': d.data ? formatDateBr(d.data) : '',
      'Categoria': d.categoria || '',
      'Tipo': d.tipo || '',
      'Status': d.status || '',
      'Andamento': d.andamento || '',
      'Observações': d.observacoes || '',
    }));

    const ws = XLSX.utils.json_to_sheet(sheetData);
    ws['!cols'] = [
      { wch: 28 }, { wch: 32 }, { wch: 10 }, { wch: 42 },
      { wch: 14 }, { wch: 14 }, { wch: 14 },
      { wch: 12 }, { wch: 22 }, { wch: 14 }, { wch: 12 }, { wch: 14 }, { wch: 40 },
    ];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Investimentos');

    let suffix = periodo === 'mensal'
      ? `${ano}-${String(mes).padStart(2, '0')}`
      : periodo === 'anual' ? String(ano)
      : periodo === 'todos' ? 'todos'
      : periodo;

    XLSX.writeFile(wb, `investimentos_${suffix}.xlsx`);
    setOpenExportModal(false);
    setSnackbar({ open: true, message: `${rows.length} registros exportados com sucesso!`, severity: 'success' });
  };

  return (
    <Box
      sx={{
        background: theme.palette.background.default,
        minHeight: '100vh',
        p: { xs: 1, sm: 2, md: 3 },
      }}
    >
      <Box sx={{ maxWidth: 1600, mx: 'auto' }}>
        {/* Cabeçalho */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 3,
            flexDirection: { xs: 'column', sm: 'row' },
            gap: 2,
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', mb: { xs: 1, sm: 0 } }}>
            <Button
              variant="text"
              startIcon={<ArrowBackIcon />}
              onClick={() => navigate(-1)}
              sx={{ mr: 2 }}
            >
              Voltar
            </Button>
            <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold' }}>
              Investimento
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
            <Button
              variant="outlined"
              color="success"
              startIcon={<ExportIcon />}
              onClick={() => setOpenExportModal(true)}
              size={isMobile ? 'small' : 'medium'}
            >
              Exportar Excel
            </Button>
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={handleNovaDespesa}
              size={isMobile ? 'small' : 'medium'}
            >
              Novo Investimento
            </Button>
          </Box>
        </Box>

        {/* Loading */}
        {loading && <LinearProgress sx={{ mb: 2 }} />}

        {/* Filtros */}
        <Paper
          sx={{ p: 2, mb: 3, borderRadius: 2, bgcolor: '#f8f9fa', border: '1px solid #e0e0e0' }}
        >
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
            <Box sx={{ flex: '1 1 220px', minWidth: { xs: '100%', sm: 220 } }}>
              <TextField
                select
                fullWidth
                size="small"
                label="Cliente *"
                value={filtroCliente}
                onChange={(e) => setFiltroCliente(e.target.value)}
                helperText={!filtroCliente ? 'Selecione um cliente para carregar os registros' : ''}
                sx={!filtroCliente ? { '& .MuiOutlinedInput-root fieldset': { borderColor: 'orange', borderWidth: 2 } } : {}}
              >
                <MenuItem value="">Selecione um cliente</MenuItem>
                <MenuItem value="all">TODOS</MenuItem>
                {clientes.map((c) => (
                  <MenuItem key={c.id} value={c.id}>
                    {c.nome}
                  </MenuItem>
                ))}
              </TextField>
            </Box>
            <Box sx={{ flex: '1 1 220px', minWidth: { xs: '100%', sm: 220 } }}>
              <TextField
                select
                fullWidth
                size="small"
                label="Situação"
                value={filtroSituacao}
                onChange={(e) => setFiltroSituacao(e.target.value)}
              >
                <MenuItem value="">TODOS GERAL</MenuItem>
                <MenuItem value="pago">Pago / Concluído</MenuItem>
                <MenuItem value="pendente">Pendente / A Pagar</MenuItem>
                <MenuItem value="cancelado">Cancelado</MenuItem>
              </TextField>
            </Box>
            <Box sx={{ flex: '1 1 220px', minWidth: { xs: '100%', sm: 220 } }}>
              <TextField
                select
                fullWidth
                size="small"
                label="Fornecedor"
                value={filtroFornecedor}
                onChange={(e) => setFiltroFornecedor(e.target.value)}
              >
                <MenuItem value="">TODOS GERAL</MenuItem>
                {fornecedores.map((f) => (
                  <MenuItem key={f.id} value={f.id}>
                    {f.nome || f.razao_social || `Fornecedor #${f.id}`}
                  </MenuItem>
                ))}
              </TextField>
            </Box>
            <Box sx={{ flex: '1 1 220px', minWidth: { xs: '100%', sm: 220 } }}>
              <TextField
                fullWidth
                size="small"
                type="date"
                label="Data Início"
                value={filtroDataInicio}
                onChange={(e) => setFiltroDataInicio(e.target.value)}
                InputLabelProps={{ shrink: true }}
              />
            </Box>
            <Box sx={{ flex: '1 1 220px', minWidth: { xs: '100%', sm: 220 } }}>
              <TextField
                fullWidth
                size="small"
                type="date"
                label="Data Fim"
                value={filtroDataFim}
                onChange={(e) => setFiltroDataFim(e.target.value)}
                InputLabelProps={{ shrink: true }}
              />
            </Box>
            <Box sx={{ flex: '1 1 220px', minWidth: { xs: '100%', sm: 220 } }}>
              <TextField
                fullWidth
                size="small"
                label="Nº OS"
                value={filtroOS}
                onChange={(e) => setFiltroOS(e.target.value)}
              />
            </Box>
            <Box sx={{ flex: '1 1 220px', minWidth: { xs: '100%', sm: 220 } }}>
              <TextField
                select
                fullWidth
                size="small"
                label="Categoria"
                value={filtroCategoria}
                onChange={(e) => setFiltroCategoria(e.target.value)}
              >
                <MenuItem value="">TODOS GERAL</MenuItem>
                {CATEGORIAS_INVESTIMENTO.map((cat) => (
                  <MenuItem key={cat} value={cat}>
                    {cat}
                  </MenuItem>
                ))}
              </TextField>
            </Box>
            <Box sx={{ flex: '1 1 220px', minWidth: { xs: '100%', sm: 220 } }}>
              <TextField
                select
                fullWidth
                size="small"
                label="Tipo"
                value={filtroTipo}
                onChange={(e) => setFiltroTipo(e.target.value)}
              >
                <MenuItem value="">TODOS GERAL</MenuItem>
                {TIPOS_INVESTIMENTO.map((t) => (
                  <MenuItem key={t} value={t}>
                    {t}
                  </MenuItem>
                ))}
              </TextField>
            </Box>
            <Box sx={{ flex: '1 1 220px', minWidth: { xs: '100%', sm: 220 } }}>
              <TextField
                select
                fullWidth
                size="small"
                label="Andamento"
                value={filtroAndamento}
                onChange={(e) => setFiltroAndamento(e.target.value)}
              >
                <MenuItem value="">TODOS GERAL</MenuItem>
                <MenuItem value="Em andamento">Em andamento</MenuItem>
                <MenuItem value="Encerrado">Encerrado</MenuItem>
              </TextField>
            </Box>
          </Box>

          <Box
            sx={{
              mt: 3,
              pt: 2,
              borderTop: '1px solid #e0e0e0',
              display: 'flex',
              justifyContent: 'flex-end',
              gap: 3,
              flexWrap: 'wrap',
            }}
          >
            {totalDescontosValor > 0 && (
              <Typography variant="h6" color="success.main" sx={{ fontWeight: 'bold' }}>
                Total Descontos:{' '}
                {Number(totalDescontosValor).toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                })}
              </Typography>
            )}
            <Typography variant="h6" color="primary" sx={{ fontWeight: 'bold' }}>
              Total Filtrado:{' '}
              {Number(totalDespesasValor).toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
              })}
            </Typography>
            {totalDescontosValor > 0 && (
              <Typography variant="h6" color="text.secondary" sx={{ fontWeight: 'bold' }}>
                Líquido:{' '}
                {Number(totalDespesasValor - totalDescontosValor).toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                })}
              </Typography>
            )}
          </Box>
        </Paper>

        {/* Abas: Investimentos / Descontos */}
        <Paper sx={{ mb: 2, borderRadius: 2 }}>
          <Tabs value={activeTab} onChange={(e, v) => setActiveTab(v)} variant="fullWidth">
            <Tab label="Investimentos" />
            <Tab label="Contratos" />
            <Tab
              label={`Descontos${despesasFiltradas.filter((d) => Number(d.desconto) > 0).length > 0 ? ` (${despesasFiltradas.filter((d) => Number(d.desconto) > 0).length})` : ''}`}
            />
          </Tabs>
        </Paper>

        {activeTab === 2 ? (
          /* Aba de Descontos */
          <Paper sx={{ borderRadius: 2, overflow: 'hidden' }}>
            <Box sx={{ p: 2, bgcolor: '#e8f5e9', borderBottom: '1px solid #c8e6c9' }}>
              <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#2e7d32' }}>
                Notas com Desconto
              </Typography>
            </Box>
            {despesasFiltradas.filter((d) => Number(d.desconto) > 0).length === 0 ? (
              <Box sx={{ p: 4, textAlign: 'center' }}>
                <Typography variant="body2" color="text.secondary">
                  Nenhuma despesa com desconto encontrada
                </Typography>
              </Box>
            ) : (
              <>
                <TableContainer>
                  <Table size="small">
                    <TableHead sx={{ backgroundColor: '#2e7d32' }}>
                      <TableRow>
                        <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Cliente</TableCell>
                        <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>
                          Fornecedor
                        </TableCell>
                        <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>OS</TableCell>
                        <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Serviço</TableCell>
                        <TableCell sx={{ color: 'white', fontWeight: 'bold' }} align="right">
                          Valor
                        </TableCell>
                        <TableCell sx={{ color: 'white', fontWeight: 'bold' }} align="right">
                          Desconto
                        </TableCell>
                        <TableCell sx={{ color: 'white', fontWeight: 'bold' }} align="right">
                          Líquido
                        </TableCell>
                        <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Data</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {despesasFiltradas
                        .filter((d) => Number(d.desconto) > 0)
                        .map((despesa, index) => {
                          const clienteIdAtual = despesa.cliente_id ?? despesa.id_cliente;
                          const clienteNome = clienteIdAtual
                            ? clientes.find((c) => String(c.id) === String(clienteIdAtual))?.nome ||
                              `ID: ${clienteIdAtual}`
                            : 'Geral';
                          const fornecedorNome = despesa.fornecedor_id
                            ? fornecedores.find((f) => f.id === despesa.fornecedor_id)?.nome || '-'
                            : '-';
                          const valorNum = Number(despesa.valor || 0);
                          const descontoNum = Number(despesa.desconto || 0);
                          return (
                            <TableRow key={despesa.id || index} hover>
                              <TableCell>{clienteNome}</TableCell>
                              <TableCell>{fornecedorNome}</TableCell>
                              <TableCell>{despesa.numero_os || '-'}</TableCell>
                              <TableCell>{despesa.servico || '-'}</TableCell>
                              <TableCell align="right">
                                {valorNum.toLocaleString('pt-BR', {
                                  style: 'currency',
                                  currency: 'BRL',
                                })}
                              </TableCell>
                              <TableCell align="right" sx={{ color: '#2e7d32', fontWeight: 600 }}>
                                {descontoNum.toLocaleString('pt-BR', {
                                  style: 'currency',
                                  currency: 'BRL',
                                })}
                              </TableCell>
                              <TableCell align="right" sx={{ fontWeight: 600 }}>
                                {(valorNum - descontoNum).toLocaleString('pt-BR', {
                                  style: 'currency',
                                  currency: 'BRL',
                                })}
                              </TableCell>
                              <TableCell>
                                {despesa.data ? formatDateBr(despesa.data) : '-'}
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      {/* Linha de totais */}
                      <TableRow
                        sx={{
                          '& td': {
                            fontWeight: 700,
                            bgcolor: '#e8f5e9',
                            borderTop: '2px solid #2e7d32',
                          },
                        }}
                      >
                        <TableCell colSpan={4}>TOTAL</TableCell>
                        <TableCell align="right">
                          {despesasFiltradas
                            .filter((d) => Number(d.desconto) > 0)
                            .reduce((s, d) => s + Number(d.valor || 0), 0)
                            .toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                        </TableCell>
                        <TableCell align="right" sx={{ color: '#2e7d32' }}>
                          {despesasFiltradas
                            .filter((d) => Number(d.desconto) > 0)
                            .reduce((s, d) => s + Number(d.desconto || 0), 0)
                            .toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                        </TableCell>
                        <TableCell align="right">
                          {despesasFiltradas
                            .filter((d) => Number(d.desconto) > 0)
                            .reduce(
                              (s, d) => s + (Number(d.valor || 0) - Number(d.desconto || 0)),
                              0
                            )
                            .toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                        </TableCell>
                        <TableCell />
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </>
            )}
          </Paper>
        ) : activeTab === 1 ? (
          /* Aba de Contratos */
          (() => {
            const fmtVal = (v) => Number(v||0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
            const fmtDate = (d) => { if (!d) return '—'; const p = String(d).split('-'); return p.length === 3 ? `${p[2]}/${p[1]}/${p[0]}` : d; };
            const diasBadge = (dataFim, situacao) => {
              if (!dataFim) return null;
              const sit = (situacao||'').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,'');
              const hoje = new Date(); hoje.setHours(0,0,0,0);
              const fim = new Date(dataFim + 'T00:00:00'); fim.setHours(0,0,0,0);
              const dias = Math.round((fim - hoje) / 86400000);
              if (sit === 'concluido') return { label: `Concluído ${fmtDate(dataFim)}`, bg: '#4caf50' };
              if (dias < 0) return { label: `${Math.abs(dias)}d atraso`, bg: '#f44336' };
              if (dias <= 30) return { label: `${dias}d restam`, bg: '#ff9800' };
              return { label: `${dias}d restam`, bg: '#4caf50' };
            };

            // Filtra apenas por cliente (para calcular total do cliente)
            const byCliente = contratosData.filter(c =>
              !contratosClienteId || String(c.cliente_id) === String(contratosClienteId)
            );
            // Filtra por cliente + status
            const bySituacao = byCliente.filter(c =>
              !contratosSituacao || (c.situacao||'').toLowerCase() === contratosSituacao.toLowerCase()
            );
            // Filtra completo (cliente + status + busca)
            const filtered = bySituacao.filter(c =>
              !contratosSearch || [c.numero_os, c.prestador, c.prestador_exibicao, c.cliente, c.cliente_nome]
                .filter(Boolean).join(' ').toLowerCase().includes(contratosSearch.toLowerCase())
            );

            const totalCliente = byCliente.reduce((s, c) => s + Number(c.valor||0), 0);
            const totalSituacao = bySituacao.reduce((s, c) => s + Number(c.valor||0), 0);

            return (
              <Paper sx={{ borderRadius: 2, overflow: 'hidden' }}>
                {/* Barra de filtros */}
                <Box sx={{ p: 2, bgcolor: '#e3f2fd', borderBottom: '1px solid #bbdefb', display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center' }}>
                  <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#1565c0' }}>Contratos</Typography>

                  <FormControl size="small" sx={{ minWidth: 220 }}>
                    <InputLabel>Cliente</InputLabel>
                    <Select value={contratosClienteId} label="Cliente" onChange={(e) => setContratosClienteId(e.target.value)}>
                      <MenuItem value="">Todos</MenuItem>
                      {clientes.map((c) => <MenuItem key={c.id} value={String(c.id)}>{c.nome}</MenuItem>)}
                    </Select>
                  </FormControl>

                  <FormControl size="small" sx={{ minWidth: 180 }}>
                    <InputLabel>Situação</InputLabel>
                    <Select value={contratosSituacao} label="Situação" onChange={(e) => setContratosSituacao(e.target.value)}>
                      <MenuItem value="">Todas</MenuItem>
                      <MenuItem value="Em andamento">Em andamento</MenuItem>
                      <MenuItem value="Concluído">Concluído</MenuItem>
                      <MenuItem value="Cancelado">Cancelado</MenuItem>
                      <MenuItem value="Suspenso">Suspenso</MenuItem>
                    </Select>
                  </FormControl>

                  <TextField
                    size="small" placeholder="Buscar OS, prestador..."
                    sx={{ minWidth: 200 }}
                    value={contratosSearch}
                    onChange={(e) => setContratosSearch(e.target.value)}
                  />

                  {/* Total filtrado */}
                  <Box sx={{ bgcolor: '#fff', border: '1px solid #90caf9', borderRadius: 1, px: 2, py: 0.8, minWidth: 200 }}>
                    <Typography variant="caption" color="text.secondary" sx={{ display: 'block', lineHeight: 1.2 }}>
                      {contratosSituacao
                        ? `Total ${contratosSituacao}`
                        : contratosClienteId
                          ? `Total ${clientes.find(c => String(c.id) === String(contratosClienteId))?.nome || 'cliente'}`
                          : 'Total geral'}
                    </Typography>
                    <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#1565c0' }}>
                      {fmtVal(contratosSituacao ? totalSituacao : contratosClienteId ? totalCliente : contratosData.reduce((s, c) => s + Number(c.valor||0), 0))}
                    </Typography>
                  </Box>

                  <Box sx={{ ml: 'auto', display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Chip label={`${filtered.length} contratos`} color="primary" size="small" />
                    <Button size="small" variant="outlined" onClick={() => fetchContratos()} disabled={contratosLoading}>
                      {contratosLoading ? 'Carregando...' : 'Atualizar'}
                    </Button>
                  </Box>
                </Box>

                {contratosLoading ? <LinearProgress /> : filtered.length === 0 ? (
                  <Box sx={{ p: 4, textAlign: 'center' }}>
                    <Typography variant="body2" color="text.secondary">
                      {contratosClienteId ? 'Nenhum contrato encontrado para este cliente.' : 'Selecione um cliente ou situação para ver os contratos.'}
                    </Typography>
                  </Box>
                ) : (
                  <TableContainer>
                    <Table size="small">
                      <TableHead sx={{ bgcolor: '#1565c0' }}>
                        <TableRow>
                          {['O.S','Cliente','Prestador','Valor','Data Início','Data Fim','Tipo','Situação'].map(h => (
                            <TableCell key={h} sx={{ color: '#fff', fontWeight: 'bold', fontSize: '0.75rem' }}>{h}</TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {filtered.map((c, i) => {
                          const badge = diasBadge(c.data_fim || c.dataFim, c.situacao);
                          const clienteNome = c.cliente || c.cliente_nome || clientes.find(cl => String(cl.id) === String(c.cliente_id))?.nome || `ID: ${c.cliente_id}`;
                          return (
                            <TableRow key={c.id || i} hover>
                              <TableCell sx={{ fontSize: '0.75rem' }}>{c.numero_os || '—'}</TableCell>
                              <TableCell sx={{ fontSize: '0.75rem' }}>{clienteNome}</TableCell>
                              <TableCell sx={{ fontSize: '0.75rem', maxWidth: 180, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                {c.prestador_exibicao || c.prestador || '—'}
                              </TableCell>
                              <TableCell sx={{ fontSize: '0.75rem', fontWeight: 600 }}>{fmtVal(c.valor)}</TableCell>
                              <TableCell sx={{ fontSize: '0.75rem' }}>{fmtDate(c.data_inicio || c.dataInicio)}</TableCell>
                              <TableCell sx={{ fontSize: '0.75rem' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexWrap: 'wrap' }}>
                                  {fmtDate(c.data_fim || c.dataFim)}
                                  {badge && (
                                    <Chip label={badge.label} size="small"
                                      sx={{ bgcolor: badge.bg, color: '#fff', height: 18, fontSize: '0.6rem', fontWeight: 700 }} />
                                  )}
                                </Box>
                              </TableCell>
                              <TableCell sx={{ fontSize: '0.75rem' }}>{c.tipo || '—'}</TableCell>
                              <TableCell sx={{ fontSize: '0.75rem' }}>{c.situacao || '—'}</TableCell>
                            </TableRow>
                          );
                        })}
                        {/* Linha de total */}
                        <TableRow sx={{ bgcolor: '#e3f2fd' }}>
                          <TableCell colSpan={3} sx={{ fontWeight: 700, fontSize: '0.75rem' }}>TOTAL FILTRADO</TableCell>
                          <TableCell sx={{ fontWeight: 700, fontSize: '0.75rem', color: '#1565c0' }}>
                            {fmtVal(filtered.reduce((s, c) => s + Number(c.valor||0), 0))}
                          </TableCell>
                          <TableCell colSpan={4} />
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
              </Paper>
            );
          })()
        ) : (
          <>
            {/* Tabela */}
            {/* Tabela ou Cards */}
            {isMobile ? (
              <>
              <Box sx={{ mt: 2 }}>
                {despesasFiltradas.slice(page * ROWS_PER_PAGE, page * ROWS_PER_PAGE + ROWS_PER_PAGE).map((despesa, index) => {
                  const isCancelado = (despesa.status || '').toLowerCase() === 'cancelado';
                  const clienteIdAtual = despesa.cliente_id ?? despesa.id_cliente;
                  const clienteNome = clienteIdAtual
                    ? clientes.find((c) => String(c.id) === String(clienteIdAtual))?.nome ||
                      `ID: ${clienteIdAtual}`
                    : 'Geral';
                  return (
                    <Card
                      key={despesa.id || index}
                      sx={{
                        mb: 2,
                        borderRadius: 2,
                        opacity: isCancelado ? 0.6 : 1,
                        textDecoration: isCancelado ? 'line-through' : 'none',
                      }}
                    >
                      <CardContent>
                        <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                          Cliente: {clienteNome}
                        </Typography>
                        {despesa.fornecedor_id && (
                          <Typography variant="body2">
                            Fornecedor:{' '}
                            {fornecedores.find((f) => f.id === despesa.fornecedor_id)?.nome || '-'}
                          </Typography>
                        )}
                        {despesa.numero_os && (
                          <Typography variant="body2">OS: {despesa.numero_os}</Typography>
                        )}
                        <Typography variant="body2">Serviço: {despesa.servico || '-'}</Typography>
                        <Typography variant="body2">
                          Valor:{' '}
                          {Number(despesa.valor || 0).toLocaleString('pt-BR', {
                            style: 'currency',
                            currency: 'BRL',
                          })}
                        </Typography>
                        {Number(despesa.desconto) > 0 && (
                          <Typography variant="body2" color="success.main">
                            Desconto:{' '}
                            {Number(despesa.desconto).toLocaleString('pt-BR', {
                              style: 'currency',
                              currency: 'BRL',
                            })}
                          </Typography>
                        )}
                        <Typography variant="body2">
                          Data: {despesa.data ? formatDateBr(despesa.data) : '-'}
                        </Typography>
                        <Typography variant="body2">
                          Categoria: {despesa.categoria || 'Geral'}
                        </Typography>
                        {isFromConsultaOsNfe(despesa) && (
                          <Chip
                            label="Enviado Consulta OS/NFE"
                            size="small"
                            color="info"
                            variant="outlined"
                            sx={{ mt: 1 }}
                          />
                        )}
                        {despesa.tipo && (
                          <Typography variant="body2">Tipo: {despesa.tipo}</Typography>
                        )}
                        <Typography variant="body2" sx={{ mt: 1 }}>
                          Status:{' '}
                          <Chip
                            label={despesa.status || 'aberto'}
                            color={getStatusColor(despesa.status)}
                            size="small"
                          />
                        </Typography>
                        {despesa.andamento && (
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.5 }}>
                            <Chip
                              label={despesa.andamento}
                              size="small"
                              color={despesa.andamento === 'Em andamento' ? 'warning' : 'default'}
                            />
                            {isEmAndamentoAtrasado(despesa) && (
                              <Tooltip title="Em andamento há mais de 3 dias sem alteração">
                                <WarningAmberIcon sx={{ color: '#e91e63', fontSize: 18 }} />
                              </Tooltip>
                            )}
                          </Box>
                        )}
                        <Box sx={{ mt: 2, display: 'flex', gap: 1 }}>
                          <IconButton
                            size="small"
                            color="primary"
                            onClick={() => handleView(despesa)}
                          >
                            <ViewIcon />
                          </IconButton>
                          <IconButton
                            size="small"
                            color="primary"
                            onClick={() => handleEdit(despesa)}
                            disabled={isCancelado}
                          >
                            <EditIcon />
                          </IconButton>
                          <IconButton
                            size="small"
                            color="error"
                            onClick={() => handleDelete(despesa)}
                            disabled={isCancelado}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Box>
                      </CardContent>
                    </Card>
                  );
                })}
                {!loading && !filtroCliente && despesasFiltradas.length === 0 && (
                  <Typography variant="body2" color="text.secondary" align="center" sx={{ py: 4 }}>
                    Selecione um cliente para carregar as despesas.
                  </Typography>
                )}
                {!loading && filtroCliente && despesasFiltradas.length === 0 && (
                  <Typography variant="body2" color="text.secondary" align="center" sx={{ py: 4 }}>
                    Nenhuma despesa encontrada para este cliente.
                  </Typography>
                )}
              </Box>
              {despesasFiltradas.length > ROWS_PER_PAGE && (
                <TablePagination
                  component="div"
                  count={despesasFiltradas.length}
                  page={page}
                  onPageChange={(_, v) => setPage(v)}
                  rowsPerPage={ROWS_PER_PAGE}
                  rowsPerPageOptions={[ROWS_PER_PAGE]}
                  labelDisplayedRows={({ from, to, count }) => `${from}–${to} de ${count}`}
                />
              )}
              </>
            ) : (
              <>
              <TableContainer component={Paper} sx={{ borderRadius: 2 }}>
                <Table size="small" sx={{ tableLayout: 'fixed', width: '100%' }}>
                  <TableHead sx={{ backgroundColor: theme.palette.primary.main }}>
                    <TableRow>
                      <TableCell
                        sx={{
                          color: 'white',
                          fontWeight: 'bold',
                          width: '12%',
                          whiteSpace: 'nowrap',
                          px: 1,
                        }}
                      >
                        Cliente
                      </TableCell>
                      <TableCell
                        sx={{
                          color: 'white',
                          fontWeight: 'bold',
                          width: '13%',
                          whiteSpace: 'nowrap',
                          px: 1,
                        }}
                      >
                        Fornecedor
                      </TableCell>
                      <TableCell
                        sx={{
                          color: 'white',
                          fontWeight: 'bold',
                          width: '6%',
                          whiteSpace: 'nowrap',
                          px: 1,
                        }}
                      >
                        OS
                      </TableCell>
                      <TableCell sx={{ color: 'white', fontWeight: 'bold', width: '15%', px: 1 }}>
                        Serviço
                      </TableCell>
                      <TableCell
                        sx={{
                          color: 'white',
                          fontWeight: 'bold',
                          width: '8%',
                          whiteSpace: 'nowrap',
                          px: 1,
                        }}
                      >
                        Valor
                      </TableCell>
                      <TableCell
                        sx={{
                          color: 'white',
                          fontWeight: 'bold',
                          width: '8%',
                          whiteSpace: 'nowrap',
                          px: 1,
                        }}
                      >
                        Desconto
                      </TableCell>
                      <TableCell
                        sx={{
                          color: 'white',
                          fontWeight: 'bold',
                          width: '9%',
                          whiteSpace: 'nowrap',
                          px: 1,
                        }}
                      >
                        Data
                      </TableCell>
                      <TableCell sx={{ color: 'white', fontWeight: 'bold', width: '9%', px: 1 }}>
                        Categoria
                      </TableCell>
                      <TableCell sx={{ color: 'white', fontWeight: 'bold', width: '5%', px: 1 }}>
                        Tipo
                      </TableCell>
                      <TableCell sx={{ color: 'white', fontWeight: 'bold', width: '7%', px: 1 }}>
                        Status
                      </TableCell>
                      <TableCell sx={{ color: 'white', fontWeight: 'bold', width: '8%', px: 1 }}>
                        Andamento
                      </TableCell>
                      <TableCell
                        sx={{
                          color: 'white',
                          fontWeight: 'bold',
                          width: '8%',
                          whiteSpace: 'nowrap',
                          px: 1,
                        }}
                      >
                        Ações
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {despesasFiltradas.slice(page * ROWS_PER_PAGE, page * ROWS_PER_PAGE + ROWS_PER_PAGE).map((despesa, index) => {
                      const isCancelado = (despesa.status || '').toLowerCase() === 'cancelado';
                      const atrasado = isEmAndamentoAtrasado(despesa);
                      const clienteIdAtual = despesa.cliente_id ?? despesa.id_cliente;
                      return (
                        <TableRow
                          key={despesa.id || index}
                          hover
                          sx={{
                            backgroundColor: isCancelado
                              ? '#fde2e4'
                              : atrasado
                              ? '#fce4ec'
                              : 'transparent',
                            borderLeft: isCancelado
                              ? '6px solid #f48fb1'
                              : atrasado
                              ? '6px solid #e91e63'
                              : 'none',
                            '&:hover': {
                              backgroundColor: isCancelado
                                ? '#f8c7cf'
                                : atrasado
                                ? '#f8bbd0'
                                : 'rgba(0,0,0,0.04)',
                            },
                          }}
                        >
                          <TableCell sx={{ px: 1, fontSize: '0.8rem' }}>
                            {clienteIdAtual
                              ? clientes.find((c) => String(c.id) === String(clienteIdAtual))
                                  ?.nome || `ID: ${clienteIdAtual}`
                              : 'Geral'}
                          </TableCell>
                          <TableCell sx={{ px: 1, fontSize: '0.8rem' }}>
                            {despesa.fornecedor_id
                              ? fornecedores.find((f) => f.id === despesa.fornecedor_id)?.nome ||
                                '-'
                              : '-'}
                          </TableCell>
                          <TableCell sx={{ px: 1, fontSize: '0.8rem' }}>
                            {despesa.numero_os || '-'}
                          </TableCell>
                          <TableCell sx={{ px: 1, fontSize: '0.8rem' }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                              <Typography variant="body2" sx={{ fontSize: '0.8rem' }}>
                                {despesa.servico}
                              </Typography>
                              {isFromConsultaOsNfe(despesa) && (
                                <Chip
                                  label="Enviado Consulta OS/NFE"
                                  size="small"
                                  color="info"
                                  variant="outlined"
                                  sx={{ width: 'fit-content' }}
                                />
                              )}
                            </Box>
                          </TableCell>
                          <TableCell sx={{ px: 1, fontSize: '0.8rem', whiteSpace: 'nowrap' }}>
                            R${' '}
                            {Number(despesa.valor || 0).toLocaleString('pt-BR', {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </TableCell>
                          <TableCell sx={{ px: 1, fontSize: '0.8rem' }}>
                            {Number(despesa.desconto || 0) > 0 ? (
                              <Typography
                                variant="body2"
                                color="success.main"
                                sx={{ fontWeight: 600, fontSize: '0.8rem' }}
                              >
                                R${' '}
                                {Number(despesa.desconto).toLocaleString('pt-BR', {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </Typography>
                            ) : (
                              '-'
                            )}
                          </TableCell>
                          <TableCell sx={{ px: 1, fontSize: '0.8rem', whiteSpace: 'nowrap' }}>
                            {despesa.data ? formatDateBr(despesa.data) : '-'}
                          </TableCell>
                          <TableCell sx={{ px: 1, fontSize: '0.8rem' }}>
                            {despesa.categoria}
                          </TableCell>
                          <TableCell sx={{ px: 1, fontSize: '0.8rem' }}>
                            {despesa.tipo || '-'}
                          </TableCell>
                          <TableCell sx={{ px: 0.5 }}>
                            <Select
                              value={despesa.status || 'Pendente'}
                              onChange={(e) => handleStatusInline(despesa.id, e.target.value)}
                              size="small"
                              variant="standard"
                              disableUnderline
                              sx={{
                                fontSize: '0.75rem',
                                minWidth: 95,
                                '& .MuiSelect-select': {
                                  py: 0.5,
                                  px: 1,
                                  borderRadius: 1,
                                  bgcolor: (despesa.status || '').toLowerCase() === 'pago'
                                    ? '#e8f5e9'
                                    : (despesa.status || '').toLowerCase() === 'cancelado'
                                    ? '#ffebee'
                                    : '#fff8e1',
                                  color: (despesa.status || '').toLowerCase() === 'pago'
                                    ? '#2e7d32'
                                    : (despesa.status || '').toLowerCase() === 'cancelado'
                                    ? '#c62828'
                                    : '#e65100',
                                  fontWeight: 600,
                                },
                              }}
                            >
                              <MenuItem value="Pago">Pago</MenuItem>
                              <MenuItem value="Pendente">Pendente</MenuItem>
                              <MenuItem value="Cancelado">Cancelado</MenuItem>
                            </Select>
                          </TableCell>
                          <TableCell sx={{ px: 0.5 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                              <Select
                                value={despesa.andamento || ''}
                                onChange={(e) => handleAndamentoInline(despesa.id, e.target.value)}
                                size="small"
                                displayEmpty
                                variant="standard"
                                disableUnderline={!despesa.andamento}
                                sx={{
                                  fontSize: '0.75rem',
                                  minWidth: 110,
                                  '& .MuiSelect-select': {
                                    py: 0.5,
                                    px: 1,
                                    borderRadius: 1,
                                    bgcolor: despesa.andamento === 'Em andamento'
                                      ? '#fff3e0'
                                      : despesa.andamento === 'Encerrado'
                                      ? '#f5f5f5'
                                      : 'transparent',
                                    color: despesa.andamento === 'Em andamento'
                                      ? '#e65100'
                                      : despesa.andamento === 'Encerrado'
                                      ? '#616161'
                                      : '#9e9e9e',
                                    fontWeight: despesa.andamento ? 600 : 400,
                                  },
                                }}
                              >
                                <MenuItem value=""><em style={{ color: '#9e9e9e' }}>—</em></MenuItem>
                                <MenuItem value="Em andamento">Em andamento</MenuItem>
                                <MenuItem value="Encerrado">Encerrado</MenuItem>
                              </Select>
                              {atrasado && (
                                <Tooltip title="Em andamento há mais de 3 dias sem alteração">
                                  <WarningAmberIcon sx={{ color: '#e91e63', fontSize: 18 }} />
                                </Tooltip>
                              )}
                            </Box>
                          </TableCell>
                          <TableCell sx={{ px: 1, whiteSpace: 'nowrap' }}>
                            <Box sx={{ display: 'flex', gap: 0.5 }}>
                              <Tooltip title="Visualizar">
                                <IconButton size="small" color="primary" onClick={() => handleView(despesa)}>
                                  <ViewIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Editar">
                                <IconButton size="small" color="primary" onClick={() => handleEdit(despesa)}>
                                  <EditIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Duplicar">
                                <IconButton size="small" color="secondary" onClick={() => handleDuplicar(despesa)}>
                                  <DuplicateIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                              {isAdminUser && (
                                <Tooltip title="Excluir">
                                  <IconButton size="small" color="error" onClick={() => handleDelete(despesa)}>
                                    <DeleteIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                              )}
                            </Box>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                    {!loading && (
                      <>
                        {!filtroCliente && (
                          <TableRow>
                            <TableCell colSpan={10} align="center" sx={{ py: 4 }}>
                              <Typography variant="body2" color="text.secondary">
                                Selecione um cliente para carregar as despesas.
                              </Typography>
                            </TableCell>
                          </TableRow>
                        )}
                        {filtroCliente && despesasFiltradas.length === 0 && (
                          <TableRow>
                            <TableCell colSpan={10} align="center" sx={{ py: 4 }}>
                              <Typography variant="body2" color="text.secondary">
                                Nenhuma despesa encontrada para este cliente.
                              </Typography>
                            </TableCell>
                          </TableRow>
                        )}
                      </>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              {despesasFiltradas.length > ROWS_PER_PAGE && (
                <TablePagination
                  component="div"
                  count={despesasFiltradas.length}
                  page={page}
                  onPageChange={(_, v) => setPage(v)}
                  rowsPerPage={ROWS_PER_PAGE}
                  rowsPerPageOptions={[ROWS_PER_PAGE]}
                  labelDisplayedRows={({ from, to, count }) => `${from}–${to} de ${count}`}
                />
              )}
              </>
            )}
          </>
        )}

        {/* Modal de Nova Despesa */}
        <Dialog
          open={openModal}
          onClose={() => setOpenModal(false)}
          maxWidth="sm"
          fullWidth
          fullScreen={isMobile}
        >
          <DialogTitle>{editingDespesa ? 'Editar Despesa' : 'Novo investimento'}</DialogTitle>
          <DialogContent>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 1 }}>
              {editingDespesa && isFromConsultaOsNfe(editingDespesa) && (
                <Alert severity="info">
                  Este registro foi enviado pela Consulta OS/NFE. A troca entre Despesas e Valor
                  Materiais deve ser feita dentro da própria Consulta OS/NFE.
                </Alert>
              )}
              <Autocomplete
                options={clientes}
                getOptionLabel={(opt) => `${opt.id} - ${opt.nome}`}
                value={clientes.find((c) => String(c.id) === String(formData.id_cliente)) || null}
                onChange={(_, val) => setFormData((prev) => ({ ...prev, id_cliente: val ? String(val.id) : '' }))}
                isOptionEqualToValue={(opt, val) => String(opt.id) === String(val.id)}
                renderInput={(params) => <TextField {...params} label="Cliente *" required />}
                noOptionsText="Nenhum cliente encontrado"
              />
              <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start' }}>
                <Autocomplete
                  options={fornecedores}
                  getOptionLabel={(opt) => opt.nome}
                  value={fornecedores.find((f) => String(f.id) === String(formData.fornecedor_id)) || null}
                  onChange={(_, val) => setFormData((prev) => ({ ...prev, fornecedor_id: val ? String(val.id) : '' }))}
                  isOptionEqualToValue={(opt, val) => String(opt.id) === String(val.id)}
                  renderInput={(params) => <TextField {...params} label="Fornecedor" />}
                  noOptionsText="Nenhum fornecedor encontrado"
                  sx={{ flex: 1 }}
                />
                <Tooltip title="Cadastrar novo fornecedor">
                  <IconButton color="primary" onClick={() => setOpenNovoFornecedor(true)} sx={{ mt: 1 }}>
                    <AddNewIcon />
                  </IconButton>
                </Tooltip>
              </Box>
              <TextField
                key={`numero_os-${editingDespesa?.id ?? 'new'}`}
                name="numero_os"
                label="Número OS"
                defaultValue={formData.numero_os}
                onBlur={(e) => setFormData((prev) => ({ ...prev, numero_os: e.target.value }))}
                fullWidth
              />
              <TextField
                key={`servico-${editingDespesa?.id ?? 'new'}`}
                name="servico"
                label="Serviço"
                defaultValue={formData.servico}
                onBlur={(e) => setFormData((prev) => ({ ...prev, servico: e.target.value }))}
                fullWidth
                required
              />
              <Box sx={{ display: 'flex', gap: 2 }}>
                <TextField
                  name="valor"
                  label="Valor"
                  value={formData.valor !== undefined && formData.valor !== '' ? formData.valor : centsToDisplay(valorCents)}
                  onKeyDown={makeCurrencyKeyDown(setValorCents, (display) =>
                    setFormData((prev) => ({ ...prev, valor: display }))
                  )}
                  onChange={() => {}}
                  fullWidth
                  required
                  inputProps={{ inputMode: 'numeric', style: { textAlign: 'right', fontFamily: 'monospace' } }}
                  InputProps={{ startAdornment: <span style={{ marginRight: 4, color: '#555' }}>R$</span> }}
                />
                <TextField
                  name="desconto"
                  label="Desconto (R$)"
                  value={formData.desconto !== undefined && formData.desconto !== '' ? formData.desconto : centsToDisplay(descontoCents)}
                  onKeyDown={makeCurrencyKeyDown(setDescontoCents, (display) =>
                    setFormData((prev) => ({ ...prev, desconto: display }))
                  )}
                  onChange={() => {}}
                  fullWidth
                  inputProps={{ inputMode: 'numeric', style: { textAlign: 'right', fontFamily: 'monospace' } }}
                  InputProps={{ startAdornment: <span style={{ marginRight: 4, color: '#555' }}>R$</span> }}
                />
              </Box>
              <TextField
                name="data"
                label="Data"
                type="date"
                value={formData.data}
                onChange={handleInputChange}
                fullWidth
                required
                InputLabelProps={{ shrink: true }}
              />
              <Box sx={{ display: 'flex', gap: 2 }}>
                <TextField
                  name="categoria"
                  label="Categoria"
                  value={formData.categoria}
                  onChange={handleInputChange}
                  fullWidth
                  select
                >
                  <MenuItem value="">
                    <em>Selecione</em>
                  </MenuItem>
                  {[
                    'Aço',
                    'Aluguel de Equipamentos',
                    'Argamassa',
                    'Avarias',
                    'Cerâmica',
                    'Civil',
                    'Concreto',
                    'Elétrica',
                    'Elevador',
                    'Ferragens',
                    'Frete',
                    'Gerador',
                    'Gesso',
                    'Hidráulica',
                    'Incêndio',
                    'Impermeabilização',
                    'Locação',
                    'Madeira',
                    'Mão de Obra',
                    'Materiais de Construção',
                    'Mármores e Granitos',
                    'Mobiliários',
                    'Paisagismo',
                    'Pintura',
                    'Pisos e Revestimentos',
                    'Porta Pallets',
                    'Portas Rápidas',
                    'Refrigeração',
                    'Serralheria',
                    'Sinistro',
                    'Terraplanagem',
                    'Tintas',
                    'Vidros',
                    'Outros',
                  ].map((cat) => (
                    <MenuItem key={cat} value={cat}>
                      {cat}
                    </MenuItem>
                  ))}
                </TextField>
                <TextField
                  name="tipo"
                  label="Tipo"
                  value={formData.tipo}
                  onChange={handleInputChange}
                  fullWidth
                  select
                >
                  <MenuItem value="">
                    <em>Selecione</em>
                  </MenuItem>
                  {TIPOS_INVESTIMENTO.map((t) => (
                    <MenuItem key={t} value={t}>
                      {t}
                    </MenuItem>
                  ))}
                </TextField>
              </Box>
              <Box sx={{ display: 'flex', gap: 2 }}>
                <FormControl fullWidth>
                  <InputLabel>Status</InputLabel>
                  <Select
                    name="status"
                    value={formData.status}
                    onChange={handleInputChange}
                    label="Status"
                  >
                    <MenuItem value="Pendente">Pendente</MenuItem>
                    <MenuItem value="Pago">Pago</MenuItem>
                    <MenuItem value="Cancelado">Cancelado</MenuItem>
                  </Select>
                </FormControl>
                <FormControl fullWidth>
                  <InputLabel>Andamento</InputLabel>
                  <Select
                    name="andamento"
                    value={formData.andamento}
                    onChange={handleInputChange}
                    label="Andamento"
                  >
                    <MenuItem value=""><em>Nenhum</em></MenuItem>
                    <MenuItem value="Em andamento">Em andamento</MenuItem>
                    <MenuItem value="Encerrado">Encerrado</MenuItem>
                  </Select>
                </FormControl>
              </Box>
              <TextField
                key={`observacoes-${editingDespesa?.id ?? 'new'}`}
                name="observacoes"
                label="Observações"
                defaultValue={formData.observacoes}
                onBlur={(e) => setFormData((prev) => ({ ...prev, observacoes: e.target.value }))}
                fullWidth
                multiline
                rows={3}
              />

              {/* Upload de Arquivos */}
              <Box sx={{ mt: 2, p: 2, bgcolor: 'grey.50', borderRadius: 2 }}>
                <Typography variant="subtitle2" gutterBottom>
                  Anexos (Fotos, PDFs e Vídeos)
                </Typography>

                {/* Inputs ocultos */}
                <input
                  type="file"
                  accept="image/*"
                  multiple
                  ref={fotoInputRef}
                  onChange={handleFotoChange}
                  style={{ display: 'none' }}
                />
                <input
                  type="file"
                  accept=".pdf,application/pdf"
                  multiple
                  ref={docInputRef}
                  onChange={handleDocChange}
                  style={{ display: 'none' }}
                />
                <input
                  type="file"
                  accept="video/*"
                  multiple
                  ref={videoInputRef}
                  onChange={handleVideoChange}
                  style={{ display: 'none' }}
                />

                {/* Botões de upload */}
                <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mb: 2 }}>
                  <Button
                    variant="outlined"
                    size="small"
                    startIcon={<PhotoCamera />}
                    onClick={() => fotoInputRef.current?.click()}
                  >
                    Fotos
                  </Button>
                  <Button
                    variant="outlined"
                    size="small"
                    startIcon={<DocumentIcon />}
                    onClick={() => docInputRef.current?.click()}
                  >
                    PDFs
                  </Button>
                  <Button
                    variant="outlined"
                    size="small"
                    startIcon={<Videocam />}
                    onClick={() => videoInputRef.current?.click()}
                  >
                    Vídeos
                  </Button>
                </Box>

                {/* Fotos existentes (edição) */}
                {existingFotos.length > 0 && (
                  <Box sx={{ mb: 1 }}>
                    <Typography variant="caption" color="text.secondary">
                      Fotos existentes:
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mt: 0.5 }}>
                      {existingFotos.map((url, i) => (
                        <Box key={i} sx={{ position: 'relative', width: 60, height: 60 }}>
                          <img
                            src={url}
                            alt={`Foto ${i + 1}`}
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'cover',
                              borderRadius: 4,
                            }}
                          />
                        </Box>
                      ))}
                    </Box>
                  </Box>
                )}

                {/* Novas fotos */}
                {fotos.length > 0 && (
                  <Box sx={{ mb: 1 }}>
                    <Typography variant="caption" color="text.secondary">
                      Novas fotos:
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mt: 0.5 }}>
                      {fotos.map((foto, i) => (
                        <Box key={i} sx={{ position: 'relative', width: 60, height: 60 }}>
                          <img
                            src={foto.preview}
                            alt={`Nova ${i + 1}`}
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'cover',
                              borderRadius: 4,
                            }}
                          />
                          <IconButton
                            size="small"
                            onClick={() => removerFoto(i)}
                            sx={{
                              position: 'absolute',
                              top: -8,
                              right: -8,
                              bgcolor: 'background.paper',
                              p: 0.25,
                            }}
                          >
                            <CloseIcon fontSize="small" />
                          </IconButton>
                        </Box>
                      ))}
                    </Box>
                  </Box>
                )}

                {/* Documentos existentes */}
                {existingDocs.length > 0 && (
                  <Box sx={{ mb: 1 }}>
                    <Typography variant="caption" color="text.secondary">
                      PDFs existentes:
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap', mt: 0.5 }}>
                      {existingDocs.map((doc, i) => (
                        <Chip
                          key={i}
                          size="small"
                          icon={<DocumentIcon />}
                          label={typeof doc === 'string' ? doc.split('/').pop() : doc.name}
                          component="a"
                          href={typeof doc === 'string' ? doc : doc.url}
                          target="_blank"
                          clickable
                        />
                      ))}
                    </Box>
                  </Box>
                )}

                {/* Novos documentos */}
                {documentos.length > 0 && (
                  <Box sx={{ mb: 1 }}>
                    <Typography variant="caption" color="text.secondary">
                      Novos PDFs:
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap', mt: 0.5 }}>
                      {documentos.map((doc, i) => (
                        <Chip
                          key={i}
                          size="small"
                          icon={<DocumentIcon />}
                          label={doc.name}
                          onDelete={() => removerDocumento(i)}
                        />
                      ))}
                    </Box>
                  </Box>
                )}

                {/* Vídeos existentes */}
                {existingVideos.length > 0 && (
                  <Box sx={{ mb: 1 }}>
                    <Typography variant="caption" color="text.secondary">
                      Vídeos existentes:
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mt: 0.5 }}>
                      {existingVideos.map((url, i) => (
                        <Chip
                          key={i}
                          size="small"
                          icon={<Videocam />}
                          label={`Vídeo ${i + 1}`}
                          component="a"
                          href={url}
                          target="_blank"
                          clickable
                        />
                      ))}
                    </Box>
                  </Box>
                )}

                {/* Novos vídeos */}
                {videos.length > 0 && (
                  <Box sx={{ mb: 1 }}>
                    <Typography variant="caption" color="text.secondary">
                      Novos vídeos:
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap', mt: 0.5 }}>
                      {videos.map((video, i) => (
                        <Chip
                          key={i}
                          size="small"
                          icon={<Videocam />}
                          label={video.file.name}
                          onDelete={() => removerVideo(i)}
                        />
                      ))}
                    </Box>
                  </Box>
                )}
              </Box>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenModal(false)}>Cancelar</Button>
            <Button onClick={handleSubmit} variant="contained" disabled={saving}>
              {saving ? 'Salvando...' : 'Salvar'}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Modal de Novo Fornecedor (rápido) */}
        <Dialog
          open={openNovoFornecedor}
          onClose={() => setOpenNovoFornecedor(false)}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle>Novo Fornecedor</DialogTitle>
          <DialogContent>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 1 }}>
              <TextField
                label="Nome *"
                value={novoFornecedor.nome}
                onChange={(e) => setNovoFornecedor((p) => ({ ...p, nome: e.target.value }))}
                fullWidth
              />
              <TextField
                label="Telefone"
                value={novoFornecedor.telefone}
                onChange={(e) => setNovoFornecedor((p) => ({ ...p, telefone: e.target.value }))}
                fullWidth
              />
              <TextField
                label="Categoria"
                value={novoFornecedor.categoria}
                onChange={(e) => setNovoFornecedor((p) => ({ ...p, categoria: e.target.value }))}
                fullWidth
                select
              >
                <MenuItem value="">
                  <em>Selecione</em>
                </MenuItem>
                {CATEGORIAS_INVESTIMENTO.map((cat) => (
                  <MenuItem key={cat} value={cat}>
                    {cat}
                  </MenuItem>
                ))}
              </TextField>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenNovoFornecedor(false)}>Cancelar</Button>
            <Button
              variant="contained"
              disabled={!novoFornecedor.nome.trim()}
              onClick={async () => {
                try {
                  const res = await fetch(`${API_BASE}/fornecedores`, {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                      ...(token ? { Authorization: `Bearer ${token}` } : {}),
                    },
                    body: JSON.stringify({ fornecedor: novoFornecedor }),
                  });
                  if (res.ok) {
                    const created = await res.json();
                    await loadFornecedores();
                    setFormData((prev) => ({ ...prev, fornecedor_id: String(created.id) }));
                    setNovoFornecedor({ nome: '', telefone: '', categoria: '' });
                    setOpenNovoFornecedor(false);
                    setSnackbar({
                      open: true,
                      message: 'Fornecedor cadastrado!',
                      severity: 'success',
                    });
                  } else {
                    const err = await res.json().catch(() => ({}));
                    setSnackbar({
                      open: true,
                      message: err.detail || err.error || 'Erro ao cadastrar fornecedor',
                      severity: 'error',
                    });
                  }
                } catch (e) {
                  console.error(e);
                  setSnackbar({
                    open: true,
                    message: 'Erro ao cadastrar fornecedor',
                    severity: 'error',
                  });
                }
              }}
            >
              Salvar
            </Button>
          </DialogActions>
        </Dialog>

        {/* Modal de Upload Excel */}
        <Dialog
          open={openUploadModal}
          onClose={() => setOpenUploadModal(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>Importar Arquivo Excel</DialogTitle>
          <DialogContent>
            <Box sx={{ pt: 2 }}>
              <Alert severity="info" sx={{ mb: 2 }}>
                O arquivo deve conter as colunas: ID Cliente, Serviço, Valor, Data, Categoria,
                Status, Observações
              </Alert>

              <input
                type="file"
                accept=".xlsx,.xls"
                onChange={(e) => setUploadFile(e.target.files[0])}
                style={{ marginBottom: 16, width: '100%' }}
              />

              {uploadProgress > 0 && (
                <Box sx={{ mt: 2 }}>
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    Progresso do upload: {Math.round(uploadProgress)}%
                  </Typography>
                  <LinearProgress variant="determinate" value={uploadProgress} />
                </Box>
              )}
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenUploadModal(false)}>Cancelar</Button>
            <Button
              onClick={handleFileUpload}
              variant="contained"
              disabled={!uploadFile || uploadProgress > 0}
            >
              Importar
            </Button>
          </DialogActions>
        </Dialog>

        {/* Modal de Exportação Excel */}
        <Dialog
          open={openExportModal}
          onClose={() => setOpenExportModal(false)}
          maxWidth="sm"
          fullWidth
          fullScreen={isMobile}
          PaperProps={{ sx: { borderRadius: isMobile ? 0 : 3 } }}
        >
          <DialogTitle sx={{ fontWeight: 700, pb: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <ExportIcon color="success" />
              Exportar Investimentos — Excel
            </Box>
          </DialogTitle>
          <DialogContent dividers sx={{ p: { xs: 2, sm: 3 } }}>
            <Stack spacing={2.5}>

              {/* Período */}
              <Box>
                <Typography variant="subtitle2" sx={{ fontWeight: 700, color: 'primary.main', mb: 1 }}>
                  Período
                </Typography>
                <ToggleButtonGroup
                  value={exportOpts.periodo}
                  exclusive
                  onChange={(_, v) => { if (v) setExportOpts((o) => ({ ...o, periodo: v })); }}
                  size="small"
                  sx={{ flexWrap: 'wrap', gap: 0.5 }}
                >
                  {[
                    { v: 'ult30', l: 'Últ. 30 dias' },
                    { v: 'ult60', l: 'Últ. 60 dias' },
                    { v: 'ult90', l: 'Últ. 90 dias' },
                    { v: 'mensal', l: 'Mensal' },
                    { v: 'anual', l: 'Por Ano' },
                    { v: 'todos', l: 'Todos' },
                  ].map((p) => (
                    <ToggleButton key={p.v} value={p.v} sx={{ fontSize: '0.75rem', px: 1.5 }}>
                      {p.l}
                    </ToggleButton>
                  ))}
                </ToggleButtonGroup>

                {exportOpts.periodo === 'mensal' && (
                  <Box sx={{ display: 'flex', gap: 1.5, mt: 1.5 }}>
                    <FormControl size="small" sx={{ flex: 1 }}>
                      <InputLabel>Mês</InputLabel>
                      <Select
                        value={exportOpts.mes}
                        label="Mês"
                        onChange={(e) => setExportOpts((o) => ({ ...o, mes: e.target.value }))}
                      >
                        {MESES_EXPORT.map((m) => (
                          <MenuItem key={m.v} value={m.v}>{m.l}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <FormControl size="small" sx={{ minWidth: 110 }}>
                      <InputLabel>Ano</InputLabel>
                      <Select
                        value={exportOpts.ano}
                        label="Ano"
                        onChange={(e) => setExportOpts((o) => ({ ...o, ano: e.target.value }))}
                      >
                        {ANOS_EXPORT.map((a) => (
                          <MenuItem key={a} value={a}>{a}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                )}

                {exportOpts.periodo === 'anual' && (
                  <FormControl size="small" sx={{ mt: 1.5, minWidth: 110 }}>
                    <InputLabel>Ano</InputLabel>
                    <Select
                      value={exportOpts.ano}
                      label="Ano"
                      onChange={(e) => setExportOpts((o) => ({ ...o, ano: e.target.value }))}
                    >
                      {ANOS_EXPORT.map((a) => (
                        <MenuItem key={a} value={a}>{a}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
              </Box>

              <Divider />

              {/* Clientes */}
              <Box>
                <Typography variant="subtitle2" sx={{ fontWeight: 700, color: 'primary.main', mb: 1 }}>
                  Clientes
                </Typography>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={exportOpts.todosClientes}
                      onChange={(e) => setExportOpts((o) => ({
                        ...o,
                        todosClientes: e.target.checked,
                        clienteIds: e.target.checked ? [] : o.clienteIds,
                      }))}
                    />
                  }
                  label="Todos os clientes"
                />
                {!exportOpts.todosClientes && (
                  <FormGroup
                    sx={{
                      maxHeight: 180,
                      overflowY: 'auto',
                      border: '1px solid',
                      borderColor: 'grey.200',
                      borderRadius: 1,
                      p: 1,
                      mt: 1,
                    }}
                  >
                    {clientes.map((c) => (
                      <FormControlLabel
                        key={c.id}
                        control={
                          <Checkbox
                            size="small"
                            checked={exportOpts.clienteIds.includes(String(c.id))}
                            onChange={(e) => {
                              const id = String(c.id);
                              setExportOpts((o) => ({
                                ...o,
                                clienteIds: e.target.checked
                                  ? [...o.clienteIds, id]
                                  : o.clienteIds.filter((x) => x !== id),
                              }));
                            }}
                          />
                        }
                        label={<Typography variant="body2">{c.nome}</Typography>}
                      />
                    ))}
                  </FormGroup>
                )}
              </Box>

              <Divider />

              {/* Filtros adicionais */}
              <Box>
                <Typography variant="subtitle2" sx={{ fontWeight: 700, color: 'primary.main', mb: 1.5 }}>
                  Filtros Adicionais
                </Typography>
                <Stack spacing={1.5}>
                  <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap' }}>
                    <FormControl size="small" sx={{ flex: 1, minWidth: 160 }}>
                      <InputLabel>Fornecedor</InputLabel>
                      <Select
                        value={exportOpts.fornecedorId}
                        label="Fornecedor"
                        onChange={(e) => setExportOpts((o) => ({ ...o, fornecedorId: e.target.value }))}
                      >
                        <MenuItem value="">Todos</MenuItem>
                        {fornecedores.map((f) => (
                          <MenuItem key={f.id} value={String(f.id)}>
                            {f.nome || f.razao_social || `Fornecedor #${f.id}`}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <FormControl size="small" sx={{ flex: 1, minWidth: 140 }}>
                      <InputLabel>Tipo</InputLabel>
                      <Select
                        value={exportOpts.tipo}
                        label="Tipo"
                        onChange={(e) => setExportOpts((o) => ({ ...o, tipo: e.target.value }))}
                      >
                        <MenuItem value="">Todos</MenuItem>
                        {TIPOS_INVESTIMENTO.map((t) => (
                          <MenuItem key={t} value={t}>{t}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                  <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap' }}>
                    <FormControl size="small" sx={{ flex: 1, minWidth: 140 }}>
                      <InputLabel>Situação</InputLabel>
                      <Select
                        value={exportOpts.situacao}
                        label="Situação"
                        onChange={(e) => setExportOpts((o) => ({ ...o, situacao: e.target.value }))}
                      >
                        <MenuItem value="">Todas</MenuItem>
                        {['Pago', 'Pendente', 'Cancelado'].map((s) => (
                          <MenuItem key={s} value={s}>{s}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <FormControl size="small" sx={{ flex: 1, minWidth: 160 }}>
                      <InputLabel>Categoria</InputLabel>
                      <Select
                        value={exportOpts.categoria}
                        label="Categoria"
                        onChange={(e) => setExportOpts((o) => ({ ...o, categoria: e.target.value }))}
                      >
                        <MenuItem value="">Todas</MenuItem>
                        {CATEGORIAS_INVESTIMENTO.map((c) => (
                          <MenuItem key={c} value={c}>{c}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                </Stack>
              </Box>

              {/* Prévia da quantidade */}
              <Paper elevation={0} sx={{ p: 1.5, bgcolor: 'grey.50', borderRadius: 2, textAlign: 'center' }}>
                <Typography variant="body2" color="text.secondary">
                  Registros na seleção atual:{' '}
                  <strong style={{ color: '#1976d2' }}>
                    {(() => {
                      const { periodo, mes, ano, todosClientes, clienteIds, fornecedorId, tipo, situacao, categoria } = exportOpts;
                      const hoje = new Date();
                      let di = null, df = null;
                      if (periodo === 'ult30') { const d = new Date(hoje); d.setDate(d.getDate() - 30); di = d.toISOString().slice(0, 10); df = hoje.toISOString().slice(0, 10); }
                      else if (periodo === 'ult60') { const d = new Date(hoje); d.setDate(d.getDate() - 60); di = d.toISOString().slice(0, 10); df = hoje.toISOString().slice(0, 10); }
                      else if (periodo === 'ult90') { const d = new Date(hoje); d.setDate(d.getDate() - 90); di = d.toISOString().slice(0, 10); df = hoje.toISOString().slice(0, 10); }
                      else if (periodo === 'mensal') { const ld = new Date(ano, mes, 0).getDate(); di = `${ano}-${String(mes).padStart(2, '0')}-01`; df = `${ano}-${String(mes).padStart(2, '0')}-${String(ld).padStart(2, '0')}`; }
                      else if (periodo === 'anual') { di = `${ano}-01-01`; df = `${ano}-12-31`; }
                      return despesas.filter((d) => {
                        if (di && (!d.data || d.data < di)) return false;
                        if (df && (!d.data || d.data > df)) return false;
                        if (!todosClientes && clienteIds.length > 0 && !clienteIds.includes(String(d.cliente_id || d.id_cliente || ''))) return false;
                        if (fornecedorId && String(d.fornecedor_id) !== String(fornecedorId)) return false;
                        if (tipo && String(d.tipo || '') !== tipo) return false;
                        if (situacao && (d.status || '').toLowerCase() !== situacao.toLowerCase()) return false;
                        if (categoria && String(d.categoria || '') !== categoria) return false;
                        return true;
                      }).length;
                    })()}
                  </strong>
                </Typography>
              </Paper>

            </Stack>
          </DialogContent>
          <DialogActions sx={{ p: 2, gap: 1 }}>
            <Button onClick={() => setOpenExportModal(false)}>Cancelar</Button>
            <Button
              variant="contained"
              color="success"
              startIcon={<ExportIcon />}
              onClick={handleExportExcel}
            >
              Exportar Excel
            </Button>
          </DialogActions>
        </Dialog>

        {/* Snackbar para notificações */}
        <Snackbar
          open={snackbar.open}
          autoHideDuration={6000}
          onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
        >
          <Alert
            onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
            severity={snackbar.severity}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
      </Box>
    </Box>
  );
}

export default Despesas;
